import { Link } from "react-router-dom";
// import { Link } from "react-scroll";
import { useState, useEffect } from "react";
import { HiMenu } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import Button from "./Button";
import { HashLink } from "react-router-hash-link";
export default function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleClose() {
    setIsMenuOpen((open) => !open);
  }
  return (
    <header className="w-full fixed top-0 left-0 z-50">
      <nav
        className={`py-4 md:px-12 px-4 text-medium-black ${
          isSticky ? "sticky top-0 right-0 left-0 shadow-md bg-white " : ""
        }`}
      >
        <div className="flex items-center justify-between">
          <Link to="/" className="block font-bold cursor-pointer lg:text-2xl ">
            myFitness.
          </Link>
          {/* <div className="font-bold cursor-pointer lg:text-2xl">myFitness.</div> */}

          <div className="lg:flex items-center gap-3 hidden text-medium-black font-normal">
            <HashLink
              smooth={true}
              to="/home#hero"
              className="block text-medium-black hover:text-light-purple py-2 px-4 cursor-pointer"
            >
              Home
            </HashLink>
            <HashLink
              smooth
              to="/home#training-program"
              className="block text-medium-black hover:text-light-purple py-2 px-4 cursor-pointer"
            >
              Training Programs
            </HashLink>
            <HashLink
              smooth
              to="/home#join-community"
              className="block text-medium-black hover:text-light-purple py-2 px-4 cursor-pointer"
            >
              Join Community
            </HashLink>
            <HashLink
              smooth
              to="home/#pricing"
              className="block text-medium-black hover:text-light-purple py-2 px-4 cursor-pointer"
            >
              Pricing
            </HashLink>
          </div>

          <div className="lg:block hidden">
            <Link to="/exercise">
              <Button color="dark-blue">Free Exercises</Button>
            </Link>

            {/* <button className="px-4 py-2 bg-dark-blue text-white rounded hover:bg-light-purple transition-all duration-300">
              Free Exercises
            </button> */}
          </div>

          <button onClick={handleClose} className="lg:hidden text-3xl">
            {isMenuOpen ? <MdClose /> : <HiMenu />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="mt-6 rounded p-4 flex-col justify-center items-center text-center bg-light-purple text-white">
            <Link
              to="/home"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Home
            </Link>
            <HashLink
              smooth
              to="/home#training-program"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Training Programs
            </HashLink>
            {/* <Link
              to="/"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Home
            </Link>
            <Link
              to="/training-program"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Training Programs
            </Link> */}
            <HashLink
              smooth
              to="/home#join-community"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Join Community
            </HashLink>
            <HashLink
              smooth
              to="/home#pricing"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Pricing
            </HashLink>
            <HashLink
              smooth
              to="/exercise"
              className="block hover:text-medium-black py-2 px-4 cursor-pointer"
              onClick={handleClose}
            >
              Free Exercises
            </HashLink>
          </div>
        )}
      </nav>
    </header>
  );
}
